var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingTourEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5796 3.23556C23.4234 2.1433 21.6006 2.19517 20.5084 3.35142L9.89997 14.5813L10.0158 18.6525L14.0871 18.5367L24.6955 7.30685C25.7878 6.1506 25.7359 4.32783 24.5796 3.23556Z",
    fill: "#4CA9BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53201 8.78142C2.48676 7.19149 3.73898 5.86591 5.32892 5.82067L11.0866 5.65682C11.8816 5.6342 12.5443 6.26031 12.567 7.05528C12.5896 7.85025 11.9635 8.51304 11.1685 8.53566L5.41084 8.6995L5.82045 23.0937L20.2146 22.6841L20.0508 16.9264C20.0282 16.1314 20.6543 15.4686 21.4492 15.446C22.2442 15.4234 22.907 16.0495 22.9296 16.8445L23.0935 22.6021C23.1387 24.1921 21.8865 25.5177 20.2965 25.5629L5.90237 25.9725C4.31244 26.0178 2.98686 24.7655 2.94162 23.1756L2.53201 8.78142Z",
    fill: "#4CA9BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingTourEdit);
export default __webpack_public_path__ + "static/media/onboarding-tour-edit.b8f9a9c91d0d84ec9cc19336f62e23bd.svg";
export { ForwardRef as ReactComponent };